import { Request,BaseApiUrl } from "./api";
//客户管理模块
// 列表
export const getClientListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Client/get`, { params: params });
};
//编辑
export const editClient = (params) => {
  return Request.post(`${BaseApiUrl}/api/Client/put`, params);
};
//新增
export const addClient = (params) => {
  return Request.post(`${BaseApiUrl}/api/Client/post`, params);
};
//批量删除
export const batchDeleteClient = (params) => {
  return Request.post(`${BaseApiUrl}/api/Client/BatchDelete`, params);
};
// //批量删除
// export const batchDeleteClient = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Client/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };